<template>
  <section id="testimonials" class="section section-alt">
    <Container>
      <div class="section-head">
        <p class="eyebrow" style="justify-content: center">Testimonials</p>
        <h2 class="section-title">Loved by Our Community</h2>
        <p class="section-subtitle">
          Real words from people who've made Deyoke Foods part of their daily
          wellness routine.
        </p>
      </div>
      <div class="testimonials">
        <Testimonial
          v-for="(item, index) in testimonials"
          :key="index"
          :body="item.body"
          :user="item.user"
        />
      </div>
    </Container>
  </section>
</template>

<script setup>
import Container from "@/components/Container/Container.vue"
import { reactive } from "vue"
import Testimonial from "./Testimonial.vue"

const testimonials = reactive([
    {
        body: 'I’ve been incorporating Deyoke Foods’ turkey berry powder into my morning smoothies, and the difference is incredible! I feel more energized throughout the day, and I love knowing I’m adding such a nutritious ingredient to my diet. The flavor is subtle yet delightful, and I can’t recommend it enough!',
        user: "Sarah Mensah",
    },
    {
        body: `Deyoke Foods' turkey berry tea has become my go-to evening ritual. It’s calming and delicious, and I appreciate its health benefits. I've noticed improved digestion and a boost in my overall well-being since I started drinking it regularly. It’s a perfect way to unwind after a long day!`,
        user: "James Oppong",
    },
])
</script>

<style scoped>
.testimonials {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
  max-width: 920px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .testimonials {
    grid-template-columns: 1fr;
  }
}
</style>
